import * as PIXI from "pixi.js"
import Settings from "./Settings"

export default class ScrollManager {
    container: PIXI.Container
    isDragging: boolean = false
    targetX: number = 0
    targetY: number = 0

    static didDrag: boolean = false

    constructor(app: PIXI.Application, container: PIXI.Container) {
        this.container = container

        const maxZoom = 1.0
        const minZoom = 0.1
        const zoomSpeed = 0.001

        let mouseX = 0
        let mouseY = 0
        let prevMouseX = 0
        let prevMouseY = 0
        let mouseDeltaX = 0
        let mouseDeltaY = 0
        let mouseIsDown = false

        // container.pivot.x = 1000
        // container.pivot.y = 1000

        // container.x += 1000
        // container.y += 1000

        // center container
        // container.x += app.screen.width / 2
        // container.y += app.screen.height / 2
        // container.y -= container.height / 2

        // container.pivot.set(container.width / 2, container.height / 2)

        app.stage.interactive = true
        app.stage.hitArea = app.renderer.screen
        app.stage.on("pointerdown", (event) => {
            ScrollManager.didDrag = false
            mouseIsDown = true
            mouseX = event.data.global.x
            mouseY = event.data.global.y
            prevMouseX = mouseX
            prevMouseY = mouseY
            mouseDeltaX = 0
            mouseDeltaY = 0
        })

        app.stage.on("pointerup", (event) => {
            ScrollManager.didDrag = this.isDragging
            console.log(ScrollManager.didDrag)

            mouseIsDown = false
            this.isDragging = false
        })

        app.stage.on("pointermove", (event) => {
            if (mouseIsDown) {
                ScrollManager.didDrag = true
                this.isDragging = true
                prevMouseX = mouseX
                prevMouseY = mouseY
                mouseX = event.data.global.x
                mouseY = event.data.global.y
                mouseDeltaX = mouseX - prevMouseX
                mouseDeltaY = mouseY - prevMouseY
                this.targetX += mouseDeltaX
                this.targetY += mouseDeltaY
            }
        })

        window.addEventListener("wheel", (event) => {
            const mx = event.clientX
            const my = event.clientY
            const p = new PIXI.Point(mx, my)
            const mouseLocalPos = container.toLocal(p, app.stage)
            const pivotDeltaX = mouseLocalPos.x - container.pivot.x
            const pivotDeltaY = mouseLocalPos.y - container.pivot.y

            container.pivot.x += pivotDeltaX
            container.pivot.y += pivotDeltaY

            container.x += pivotDeltaX * container.scale.x
            container.y += pivotDeltaY * container.scale.y

            this.targetX = container.x
            this.targetY = container.y

            const offset = -event.deltaY
            let newScale = container.scale.x + offset * zoomSpeed
            newScale = Math.max(newScale, minZoom)
            newScale = Math.min(newScale, maxZoom)
            container.scale.x = newScale
            container.scale.y = newScale

            var zoomEvent = new CustomEvent("ZoomDidChange", { detail: this })
            document.dispatchEvent(zoomEvent)
        })
    }

    initPosition() {
        this.targetX = this.container.x
        this.targetY = this.container.y
    }

    update() {
        const damp = this.isDragging ? 0.5 : Settings.nodeAnimationDamping
        this.container.x += (this.targetX - this.container.x) * damp
        this.container.y += (this.targetY - this.container.y) * damp
    }
}
